export enum DeviceStatus {
  NEW = 'new',
  REQUESTED = 'requested',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  ACTIVE = 'active',
  RETIRED = 'retired',
}